import { get } from "@ember/object"
import Service, { inject as service } from "@ember/service"
import cardStackTemplatesCallback from "./callbacks/patch/card-stack-template-callback"
import clearCardsUpdatingFromTemplateCallback from "./callbacks/patch/clear-cards-updating-from-template-callback"
import type CardStackTemplateUpdater from "./card-stack-template-updater"
import type EmberStore from "./ember-store"
import type InternalSupergrainStore from "./internal-supergrain-store"
import type PhantomCardStacks from "./phantom-card-stacks"

export default class PatchCallbacks extends Service {
  cardStackIdCardCache = Object.create(null) // so it's in dictionary mode

  @service("ember-store") store!: EmberStore
  @service("internal-supergrain-store") internalSupergrainStore!: InternalSupergrainStore

  @service session

  @service rpc

  @service cardStackTemplateUpdater!: CardStackTemplateUpdater
  @service phantomCardStacks!: PhantomCardStacks

  constructor(...args) {
    super(...args)

    // @ts-ignore
    let stream = Kefir.fromEvents(get(this, "store"), "patch", (patch, actionName) => [
      patch,
      actionName,
    ])

    // @ts-ignore
    let foreignPatchStream = Kefir.fromEvents(
      get(this, "store"),
      "foreign-patch",
      (patch, actionName) => [patch, actionName]
    )

    cardStackTemplatesCallback.call(this, stream)
    cardStackTemplatesCallback.call(this, foreignPatchStream)
    clearCardsUpdatingFromTemplateCallback.call(this, foreignPatchStream)
  }
}
